// extracted by mini-css-extract-plugin
export default {"tab-item-content":"TabItemContent_tab-item-content__KNmec"};